module.exports = __webpack_public_path__ + "static/media/ideas.6467bd07.svg";